module.exports = __webpack_public_path__ + "img/2.78d15529.svg";